module.exports = __webpack_public_path__ + "static/winter-9e8178085520233f46356f5fdd9782ed.svg";